// extracted by mini-css-extract-plugin
export default {"FieldsetDescriptionButton":"FieldsetDescriptionButton_FieldsetDescriptionButton__vAH3T"};